<template>
  <div class="vuestic-page-not-found-large-text">
    <div class="vuestic-page-not-found-large-text__content">
      <div class="vuestic-page-not-found-large-text__wallpaper">
        <router-link
          class="i-vuestic vuestic-page-not-found-large-text__i-vuestic"
          :to="{path: '/'}"/>
      </div>
      <div class="vuestic-page-not-found-large-text__wallpaper">
        <img class="sys-error-img" :src="subjectAddressUrl" alt="In Maintenance">
      </div>
      <div class="vuestic-page-not-found-large-text__wallpaper">
        <h3 class="vuestic-page-not-found-large-text__text">The page's gone
          fishing.</h3>
      </div>
      <div
        class="vuestic-page-not-found-large-text__wallpaper-button flex md12" style="z-index:9999;">
        <router-link :to="{ path: '/dashboard' }">
          <button class="btn btn-primary back-button">
            {{'Back to dashboard'}}
          </button>
        </router-link>
      </div>
    </div>
    <vuestic-page-not-found-sad-wallpaper/>
  </div>
</template>

<script>
import VuesticPageNotFoundSadWallpaper from '../404-pages/VuesticPageNotFoundSadWallpaper'

export default {
  name: 'system-error',
  components: {
    VuesticPageNotFoundSadWallpaper,
  },
  data() {
    return {
      subjectAddressUrl: require('@/assets/images/error.png')
    }
  }
}
</script>

<style lang="scss">
.vuestic-page-not-found-large-text {
  min-height: 100vh;
  padding-bottom: 84px;
  background-color: rgb(238, 238, 238);
  &__text {
    color: #e34a4a;
  }
  &__text-small {
    font-size: $font-size-root;
    line-height: 1.5;
    text-align: center;
    color: white;
    font-weight: normal;
  }
  &__wallpaper {
    background-color: rgb(238, 238, 238);
    overflow: hidden;
    display: flex;
    text-align: center;
    align-items: flex-start;
    justify-content: center;

    a {
      margin-top: 2rem;
    }
  }
  &__wallpaper-button {
    padding-top: 20px;
    padding-bottom: 10px;
    text-align: center;
    background-color: rgb(238, 238, 238);
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  &__i-vuestic {
    z-index: 2;
    margin-top: 8%;
    height: $auth-wallpaper-ivuestic-h;
    width: 100%;
  }
  .sys-error-img {
    margin-top: 72px;
    max-width: 60%;
    max-height: 50%;
    border-radius: 10%;
  }
  @include media-breakpoint-down(xs) {
    .vuestic-page-not-found-large-text {
      height: $auth-mobile-main-h;

      &__wallpaper-button {
        width: 100%;
        margin-left: 0;

        .back-button {
          max-width: 300px;
          padding-left: 30px;
          padding-right: 30px;
        }
      }
      &__i-vuestic {
        margin-top: 5%;
      }
      &__text-small {
        font-size: 15px;
      }
    }
  }
}
</style>
